/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AaiServer } from '../../asyncapi/models/AaiServer';
import { Aai20Document } from '../../asyncapi/v2/models/Aai20Document';
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { Server } from '../../core/models/common/Server';
import { MarshallCompat } from '../../compat/MarshallCompat';
import { ServerVariable } from '../../core/models/common/ServerVariable';
import { Node } from '../../core/models/Node';

/**
 * A command used to modify a aaiserver.
 * @author c.desc2@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class ChangeServerCommand_Aai20 extends AbstractCommand {
    public _serverName : string;

    public _serverObj : any;

    public _oldServer : any;

    public constructor(server? : any) {
        if(((server != null && server instanceof <any>AaiServer) || server === null)) {
            let __args = arguments;
            super();
            if(this._serverName===undefined) this._serverName = null;
            if(this._serverObj===undefined) this._serverObj = null;
            if(this._oldServer===undefined) this._oldServer = null;
            if(this._serverName===undefined) this._serverName = null;
            if(this._serverObj===undefined) this._serverObj = null;
            if(this._oldServer===undefined) this._oldServer = null;
            (() => {
                this._serverName = server.getName();
                this._serverObj = Library.writeNode(server);
            })();
        } else if(server === undefined) {
            let __args = arguments;
            super();
            if(this._serverName===undefined) this._serverName = null;
            if(this._serverObj===undefined) this._serverObj = null;
            if(this._oldServer===undefined) this._oldServer = null;
            if(this._serverName===undefined) this._serverName = null;
            if(this._serverObj===undefined) this._serverObj = null;
            if(this._oldServer===undefined) this._oldServer = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[ChangeServerCommand_Aai20] Executing.");
        this._oldServer = null;
        let parent : Aai20Document = <Aai20Document>document;
        if(this.isNullOrUndefined(parent.servers)) {
            return;
        }
        let server : AaiServer = /* get */((m,k) => m[k]===undefined?null:m[k])(parent.servers, this._serverName);
        if(this.isNullOrUndefined(server)) {
            return;
        }
        this._oldServer = Library.writeNode(server);
        this.replaceServerWith(server, this._serverObj);
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[ChangeServerCommand_Aai20] Reverting.");
        if(this.isNullOrUndefined(this._oldServer)) {
            return;
        }
        let parent : Aai20Document = <Aai20Document>document;
        if(this.isNullOrUndefined(parent.servers)) {
            return;
        }
        let server : AaiServer = /* get */((m,k) => m[k]===undefined?null:m[k])(parent.servers, this._serverName);
        if(this.isNullOrUndefined(server)) {
            return;
        }
        this.replaceServerWith(server, this._oldServer);
    }

    /**
     * Replaces the content of a server with the content from another server.
     * @param {Server} toServer
     * @param {*} fromServer
     */
    replaceServerWith(toServer : Server, fromServer : any) {
        toServer.getServerVariables().forEach((var_) => {
            toServer.removeServerVariable(var_.getName());
        });
        Library.readNode(fromServer, toServer);
    }
}
ChangeServerCommand_Aai20["__class"] = "io.apicurio.datamodels.cmd.commands.ChangeServerCommand_Aai20";
ChangeServerCommand_Aai20["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




